import { render, staticRenderFns } from "./ProjectMemberGroup.vue?vue&type=template&id=580c5c78&scoped=true"
import script from "./ProjectMemberGroup.vue?vue&type=script&lang=ts"
export * from "./ProjectMemberGroup.vue?vue&type=script&lang=ts"
import style0 from "./ProjectMemberGroup.vue?vue&type=style&index=0&id=580c5c78&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580c5c78",
  null
  
)

export default component.exports